import { CloseOutlined } from "@mui/icons-material";
import { Button, CircularProgress, Dialog } from "@mui/material";
import React, { useEffect, useState } from "react";

import useService from "../../../../../hooks/useService";

export default function LawFirmDetails({
  lawFirmId,
  openLfDetails,
  setOpenLfDetails,
  //clientLawfirm,
  //setClientLawfirm
}) {
  const lawfirmRepository = useService("repositories/lawfirm-repository");
  const [clientLawfirm, setClientLawfirm] = useState(null);

  //TODO Make sure these perms work
  useEffect(() => {
    if (lawFirmId) {
      getLawFirm();
    }
  }, [lawFirmId]);

  const getLawFirm = async () => {
    try {
      const lawfirm = await lawfirmRepository.findRecord(lawFirmId);
      setClientLawfirm(lawfirm);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Dialog open={openLfDetails} fullWidth>
      <div
        style={{
          padding: 20,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            fontSize: "20px",
          }}
        >
          <Button onClick={() => setOpenLfDetails(false)}>
            <CloseOutlined />
          </Button>
        </div>
        <h1
          style={{
            fontSize: "24px",
            margin: "0 0 1rem 0",
            textAlign: "left",
            fontWeight: "bold",
            color: "#1976d2",
          }}
        >
          Law Firm Detail
        </h1>
        {!clientLawfirm ? (
          <CircularProgress color="secondary" />
        ) : (
          <div className="flex rounded-b-lg" style={{ padding: "0 0 2rem 0" }}>
            <div style={{ textAlign: "left" }}>
              <h3 className="my-2">
                <strong>Name:</strong> {clientLawfirm.name}
              </h3>
              <h3 className="my-2">
                <strong>Address:</strong> {!clientLawfirm.address ? "" : clientLawfirm.address.raw}
              </h3>
              <h3 className="my-2">
                <strong>Email:</strong>{" "}
                <a href={`mailto:${clientLawfirm.email}`} target="_blank" rel="noreferrer">
                  {clientLawfirm.email}
                </a>
              </h3>
              <h3 className="my-2">
                <strong>Lawfirm Website:</strong>{" "}
                <a href={clientLawfirm.homepage_url} target="_blank" rel="noreferrer">
                  {clientLawfirm.homepage_url}
                </a>
              </h3>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "1rem",
                }}
              >
                <h3>
                  <strong>Phone:</strong> {clientLawfirm.phone}
                  &nbsp;
                </h3>
              </div>
            </div>
          </div>
        )}
      </div>
    </Dialog>
  );
}
